/* src/app/pages/login-v2/components/support-link/support-link.component.scss */
.auth-support {
  margin: 0;
  text-align: center;
  color: var(--text-label);
  font-size: 12px;
  line-height: 16px;
}
.auth-support__link {
  border: 0;
  background: transparent;
  color: var(--primary-regular-default);
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
}
.auth-support__link:focus-visible {
  outline: 2px solid var(--primary-regular-default);
  outline-offset: 2px;
  border-radius: 4px;
}
/*# sourceMappingURL=support-link.component.css.map */
